import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IoFilterSharp } from 'react-icons/io5';
import { HiOutlineShoppingBag } from 'react-icons/hi';
import ItemService from '../service/ItemService';
import EmptyState from '../components/EmptyState';
import InfiniteProductGrid, { stylesLabel } from '../components/InfiniteProductGrid';
import useItemFeed from '../util/useItemFeed';


const findCategoryName = (display, id) => {
    if (!display) return ''
    const all = [
        ...(display.mainCategory || []),
        ...(display.subCategory || []),
        ...(display.subCategory || []).flatMap(s => s.list || [])
    ]
    const match = all.find(c => String(c.categoryId) === String(id))
    return match ? match.categoryName : ''
}

// Category page (/category/:id): the category's products, loading more as the shopper scrolls.
const PublicItemListView = () => {
    const history = useHistory();
    const { id: categoryId } = useParams();
    const feed = useItemFeed({ categoryId })
    const [categoryName, setCategoryName] = useState('')

    useEffect(() => {
        let live = true
        setCategoryName('')
        ItemService.getShopCategoriesPublic().then(response => {
            if (live && response.status) setCategoryName(findCategoryName(response.data.data, categoryId))
        }).catch(error => console.log(error))
        return () => { live = false }
    }, [categoryId])

    const openView = useCallback((id) => {
        history.push({ pathname: '/shop/items/view/' + id, state: { id } })
    }, [history])

    const redirectAllItems = () => history.push({ pathname: '/items/all/' })

    return (
        <main className='mv-page'>
            <div className='mv-list-head'>
                <div>
                    <h1 className='mv-list-title'>{categoryName || 'Shop'}</h1>
                    {feed.total > 0 && feed.status !== 'loading' &&
                        <span className='mv-list-count'>{stylesLabel(feed.total)}</span>}
                </div>
                <button type='button' className='mv-btn mv-btn-secondary mv-filter-btn' onClick={redirectAllItems}>
                    <IoFilterSharp /> Filter
                </button>
            </div>

            <InfiniteProductGrid feed={feed} onOpen={openView}
                empty={<EmptyState
                    icon={<HiOutlineShoppingBag />}
                    title='New styles coming soon'
                    text='There are no products in this category yet. Explore our full collection meanwhile.'
                    actionLabel='Browse all products'
                    onAction={redirectAllItems}
                />} />
        </main>
    );
}

export default PublicItemListView;
